// extracted by mini-css-extract-plugin
module.exports = {"AddCard":"AddCard_AddCard__0nJMC","externalPay":"AddCard_externalPay__tOIns","stripeInput":"AddCard_stripeInput__F7HPa","boxShadow":"AddCard_boxShadow__qqRAJ"};